import { get, set, clear, entries  } from 'idb-keyval';
import objectPath from "object-path";
var Store = function() {
	return {

		data: {},

		init: function( callBack ) {
			entries().then( entries => {
				//console.log(entries)
				entries.forEach( e => {
					objectPath.set( Store.data, e[ 0 ], e[ 1 ] ) 
				} )
				callBack()
			} )
		},

		clear: function() {
			clear();
		},

		set: function( inKey, inData ) {
			if ( !inKey ) {
			    console.error( 'Store.set.objectPath.set.error', 'inKey missing' )
			    return false				
			}
			objectPath.set( Store.data, inKey, JSON.parse(JSON.stringify( inData )) );
			set(inKey, inData)
		},

		get: function( inKey ) {
			let key = inKey
			if ( key && key.slice( -1 ) === '.' ) {
				key = key.slice( 0, -1 ); // if '.' last char, remove it
			}
			return objectPath.get( Store.data, key ); // returns reference to object, key can also be an array
		},

	} 
}();

export default Store

